import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { BetaProgramItem } from '../../../types/types';
import { styles } from '../view/styles';
import { LinkColor, LinkType } from '../../../../../../ui/gzLinkComponent/types';
import { GzRadioGroupWebComponent } from '../../../../../../ui/gzRadio';

export class BetaProgramSection extends LitElement {
  @property({ type: Array })
  betaProgramItems: Array<BetaProgramItem>;

  public enrolledStatusText: string;
  public notEnrolledStatusText: string;
  public learnMoreText: string;

  @query('#beta-programs-radio-group')
  private radioGroup: GzRadioGroupWebComponent;

  static get styles() {
    return styles;
  }

  shouldUpdate(): boolean {
    return this.betaProgramItems !== undefined;
  }

  updated() {
    this.radioGroup.setFormValue('');
  }

  render() {
    return html`
      <div class="wrapper">
        <gz-radio-group id="beta-programs-radio-group" groupName="beta-programs">
          ${this.renderBetaProgramRows()}
        </gz-radio-group>
      </div>
    `;
  }

  private renderBetaProgramRows() {
    return html`${this.betaProgramItems.map((betaProgramItem: BetaProgramItem) =>
      this.renderBetaProgramRow(betaProgramItem)
    )}`;
  }

  private renderBetaProgramRow(betaItem: BetaProgramItem) {
    const showIconClass = !betaItem.enrolled ? 'hidden' : '';
    const statusText = betaItem.enrolled ? this.enrolledStatusText : this.notEnrolledStatusText;

    return html`
      <div class="beta-program-row">
        <div class="beta-program-row-el">
          <gz-tooltip id="program-name-tooltip" isEllipsis tooltipText="${betaItem.programName}">
            <gz-radio class="beta-program-sub-row-el" value=${betaItem.type} label=${betaItem.programName}></gz-radio>
          </gz-tooltip>
        </div>
        <div class="beta-program-row-el">
          <gz-icon-button
            icon="ds-icon-notification_success"
            size="24"
            fontsize="20"
            buttontype="round"
            buttonfill="white"
            buttoncolor="success"
            class="check-mark-span ${showIconClass}"
          ></gz-icon-button>
          <gz-text class="status" fontSize="14">${statusText}</gz-text>
        </div>
        <div class="beta-program-row-el">
          <gz-link
            class="beta-program-sub-row-el"
            .type="${LinkType.UNDERLINE}"
            .color="${LinkColor.PRIMARY}"
            .href="${betaItem.programLink}"
            ><span>${this.learnMoreText}</span></gz-link
          >
        </div>
      </div>
    `;
  }
}
